// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CartPageTemplate, { CartPageTemplateStyles } from "@stanion/App/Components/Cart/CartPageTemplate";
import XngZone from "@stanion/App/Components/Common/XngZone";
import { xScreen } from "@stanion/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface CheckoutPageContainerStyles extends CartPageTemplateStyles {
    cartPageTemplateStyles?: CartPageTemplateStyles;
    cartApprovalMessagesWrapper?: InjectableCss;
}

export const checkoutPageContainerStyles: CheckoutPageContainerStyles = {
    cartPageTemplateStyles: {
        headerSection: {
            css: css`
                order: 1;
            `,
        },
        mainSection: {
            css: css`
                order: 2;
            `,
        },
        totalSection: {
            css: css`
                order: 3;
                ${xScreen("lte", "xs")} {
                    margin-top: 22px;
                }
            `,
        },
    },
};

const styles = checkoutPageContainerStyles;

const CheckoutPageContainer: FC<Props> = ({ id }) => {
    return (
        <CartPageTemplate extendedStyles={styles.cartPageTemplateStyles}>
            <CartPageTemplate.HeaderSection>
                <XngZone contentId={id} zoneName="Title" />
            </CartPageTemplate.HeaderSection>
            <CartPageTemplate.MainSection>
                <StyledWrapper {...styles.cartApprovalMessagesWrapper}>
                    <XngZone contentId={id} zoneName="CartApprovalMessages" />
                </StyledWrapper>
                <XngZone contentId={id} zoneName="MainContent" />
            </CartPageTemplate.MainSection>
            <CartPageTemplate.CartTotalSection>
                <XngZone contentId={id} zoneName="CheckoutTotal" />
            </CartPageTemplate.CartTotalSection>
        </CartPageTemplate>
    );
};

const widgetModule: WidgetModule = {
    component: CheckoutPageContainer,
    definition: {
        group: "Checkout - Shipping",
        allowedContexts: ["CheckoutShippingPage", "CheckoutReviewAndSubmitPage", "OrderConfirmationPage"],
        displayName: "Checkout Page Container",
        fieldDefinitions: [],
    },
};

export default widgetModule;
